import { Box } from "@mui/material";

import { Footer, Navbar } from "../../components/layout";

import Hero from "./Hero";
import PartnerMarquee from "./PartnerMarquee";
import StickyScrollRevealDemo from "./StickyScrollRevealDemo";

const HomePage = () => {
  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: "#000",
      }}
    >
      <Navbar />
      <Hero />
      <PartnerMarquee />
      <StickyScrollRevealDemo />
      <Footer />
    </Box>
  );
};

export default HomePage;
